import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = ({ praises, featuredBook, authorName }) => {
  const transmissions = featuredBook.radioTransmissions || [];
  const [currentTransmission, setCurrentTransmission] = useState(0);

  praises = praises.sort((a,b) => a.order - b.order);

  // Egérkövető effekt a 3D-s kártyákhoz és a vignette-hez
  useEffect(() => {
    const handleMouseMove = (e) => {
      // Vignette pozíció
      document.documentElement.style.setProperty('--mouse-x', `${e.clientX}px`);
      document.documentElement.style.setProperty('--mouse-y', `${e.clientY}px`);
      
      // 3D elforgatás a kártyákhoz
      const { innerWidth: width, innerHeight: height } = window;
      const { clientX: x, clientY: y } = e;
      const rotateY = (x - width / 2) / width * -20; // -10 és 10 fok között
      const rotateX = (y - height / 2) / height * 20; // -10 és 10 fok között
      document.documentElement.style.setProperty('--rotateX', `${rotateX}deg`);
      document.documentElement.style.setProperty('--rotateY', `${rotateY}deg`);
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  // Rádióüzenet váltó effekt
  useEffect(() => {
    if (transmissions.length > 0) {
      const intervalId = setInterval(() => {
        setCurrentTransmission(prevIndex => (prevIndex + 1) % transmissions.length);
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [transmissions.length]);

  return (
    <div className="home-wrapper">
      <section 
        className="hero-section" 
        style={{ backgroundImage: `url(${featuredBook.coverImage})` }}
      >
        <div className="hero-overlay"></div>
        <div className="vignette-overlay"></div>
        <div className="hero-content">
          <h2 className="hero-author">{authorName}</h2>
          <h1 className="hero-title">{featuredBook.title}</h1>
          <p className="hero-tagline">{featuredBook.tagline}</p>
          <Link to={`/konyv/${featuredBook.id}`} className="hero-cta-button">
            Túlélni mindenáron
          </Link>
          
          {transmissions.length > 0 && (
            <div className="radio-transmission">
              <p key={currentTransmission}>{transmissions[currentTransmission]}</p>
            </div>
          )}
        </div>
        
        <div className="scroll-indicator">
            <span></span>
        </div>
      </section>

      {praises.length > 0 && (
        <section className="praise-section">
          <div className="praise-grid">
            {praises.length > 0 && (
              <div className="praise-card featured-praise">
                <blockquote className="praise-quote">“{praises[0].quote}”</blockquote>
                <cite className="praise-source">— {praises[0].source}</cite>
              </div>
            )}
            
            {praises.slice(1, 3).map((praise, index) => (
              <div key={index} className="praise-card">
                <blockquote className="praise-quote">“{praise.quote}”</blockquote>
                <cite className="praise-source">— {praise.source}</cite>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default Home;